import React from 'react'
import PropTypes from 'prop-types'
import Joyride, { STATUS, ACTIONS, EVENTS, LIFECYCLE } from 'react-joyride'

/* Onbaording (via react-joyride) experience for Attention Index page */
export default class CalendarOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    run: PropTypes.bool.isRequired,
    handleTourCallBack: PropTypes.func
  }

  handleJoyrideCallback = data => {
    const { status, action, type } = data
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND, LIFECYCLE.BEACON].includes(type)) {
        if (action === ACTIONS.CLOSE || action === ACTIONS.UPDATE) {
            this.props.handleTourCallBack()
        }
    }
    else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        this.props.handleTourCallBack()
    }
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
        callback= {this.handleJoyrideCallback}
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Calendar Page!<br/><br/>This page lists the upcoming movie and show releases for the next two months.</p>),
        placement: 'center',
        disableBeacon: true,
        target: 'body'
      },
      {
        ...common,
        content: (<p>Use the top bar to search for a specific title.<br/><br/>Use the dropdowns to filter for Show or Movie type, Network, or Genre.</p>),
        target: '#calendarHeader'
      }
    ]

    return steps
  }
}
